












import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
    data() {
        const that = this;
        return {
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "displayOrder",
                    "sort-desc": false,
                },
                content: {
                    name: "Promotional News",
                    urlEnabled: true,
                    search: {
                        ext: {
                            hidden: true,
                        },
                    },
                    filters: {
                        filters: {
                            name: {
                                attrs: {
                                    label: "Name",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                        },
                    },
                    displayFields: {
                        displayOrder: {
                            text: "Display Order",
                            sortable: true,
                        },
                        name: {
                            text: "Name",
                        },
                        description: {
                            text: "Description",
                        },
                        image: {
                            text: "Image",
                        },
                        startDate: {
                            text: "Start Date",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleDateString("en-GB");
                                },
                            },
                        },
                        endDate: {
                            text: "End Date",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleDateString("en-GB");
                                },
                            },
                        },
                        createdTime: {
                            text: "Created Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        updatedTime: {
                            text: "Updated Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        action: {
                            text: "Actions",
                        },
                    },
                    topActionButtons: {
                        insert: userManager.checkRole(["systemAdmin", "admin"]) && {},
                    },
                    template: {
                        itemActionButtons: {
                            edit: userManager.checkRole(["systemAdmin", "admin"]) && {
                                target: {
                                    dialog: {
                                        ext: {
                                            subTitleMaker: "name",
                                        },
                                    },
                                },
                            },
                            delete: userManager.checkRole(["systemAdmin", "admin"]) && {},
                        },
                    },
                    findAllOptionsFilter(options) {
                        return options;
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {
                            const { items, count } = await coreApiClient.call(
                                "promotionalNews",
                                "findAll",
                                options
                            );
                            return [items, count];
                        },
                        async insert(item) {
                            const fileBase64 = await that.createImage(item.image);
                            return await coreApiClient.call(
                                "promotionalNews",
                                "create",
                                undefined,
                                { ...item, imageBase64: fileBase64 }
                            );
                        },
                        async update(item) {
                            const fileBase64 = await that.createImage(item.image);
                            return await coreApiClient.call(
                                "promotionalNews",
                                "update",
                                {
                                    id: item._id,
                                },
                                {
                                    data: { ...item, imageBase64: fileBase64 },
                                }
                            );
                        },
                        async delete(item) {
                            return await coreApiClient.call("promotionalNews", "delete", {
                                id: item._id,
                            });
                        },
                    },
                    default: {
                        defaultInputs: {
                            displayOrder: {
                                type: "number",
                                attrs: {
                                    label: "Display Order",
                                    min: 0,
                                    hint: "Lower numbers are displayed first",
                                    "persistent-hint": true,
                                },
                            },
                            name: {
                                attrs: {
                                    label: "Name",
                                    required: true,
                                },
                            },
                            description: {
                                type: "textLarge",
                                attrs: {
                                    label: "Description",
                                },
                            },
                            startDate: {
                                type: "XDateTimePicker",
                                attrs: {
                                    label: "Start Date",
                                    required: true,
                                },
                            },
                            endDate: {
                                type: "XDateTimePicker",
                                attrs: {
                                    label: "End Date",
                                    required: true,
                                },
                            },
                            image: {
                                type: "file",
                                attrs: {
                                    label: "Image",
                                    accept: "image/*",
                                    hint: "Recommended size: 1200x520 px",
                                    "persistent-hint": true,
                                },
                            },
                        },
                        insertForm: userManager.checkRole(["systemAdmin", "admin"]) && {
                            content: {
                                fieldNames: ["displayOrder", "name", "description", "startDate", "endDate", "image"],
                            },
                        },
                        editForm: userManager.checkRole(["systemAdmin", "admin"]) && {
                            content: {
                                fieldNames: ["displayOrder", "name", "description", "startDate", "endDate", "image"],
                            },
                        },
                        delete: {
                            confirmDisplayField: "name",
                        },
                    },
                },
            },
        };
    },
    methods: {
        createImage(file) {
            return new Promise((resolve, reject) => {
                if (file && typeof file !== "string") {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                } else {
                    resolve(null);
                }
            });
        },
    },
});

